import React from 'react';
import PropTypes from 'prop-types';

function FullWidthCellRenderer(props) {
	const getLeveltext = (level) => {
		if(level === 'ITEM') {
			return 'items'
		} else if(level === 'STORE') {
			return 'stores'
		} else if(level === 'ALL_LINK_NUMBER') {
			return 'all links numbers'
		} else if(level === 'PRIME_ITEM_NUMBER') {
			return 'prime item numbers'
		}
	}
	const level = getLeveltext(props?.data?.hierarchyLevel);
	const topBottom = props?.data?.sort === 'desc' ? 'Top' : 'Bottom';

	const message = `${topBottom} ${Math.min(
		props?.data?.totalRows,
		200
	)} ${level}`;

	return (
		<div
			className={`tableMessage ag-ltr ag-row-group-indent-${props?.node?.level}`}>
			{message}
		</div>
	);
}

FullWidthCellRenderer.propTypes = {
	data: PropTypes.object,
	totalRows: PropTypes.number,
	node: PropTypes.object,
	level: PropTypes.number,
	hierarchyLevel: PropTypes.string,
};

export default FullWidthCellRenderer;
